import { Button, Flex, Grid, Loader, Modal, Stack, TextInput } from "@mantine/core";
import { useForm } from "@mantine/form";
import axios from "axios";
import { createRef, useState } from "react";
import PhoneInputField from "../PhoneInputField/PhoneInputField";
import { isValidPhoneNumber } from "react-phone-number-input";
import { IconBrandWhatsapp } from "@tabler/icons-react";

export default function ContactAdviserModal({ opened, onClose, academicUnitName, academicUnitId }) {
    const modalTitle = academicUnitName ? `Podemos ayudarte con más información sobre ${academicUnitName}` : "¿Necesitás ayuda para tomar la decisión?"
    const [isLoading, setIsLoading] = useState(false)
    const form = useForm({
        initialValues: {
            name: '',
            email: '',
            phone: '',
        },

        validate: {
            name: (value) => (value.length > 5 ? null : 'Ingrese su nombre completo'),
            email: (value) => (/^\S+@\S+$/.test(value) ? null : 'El email ingresado no es valido'),
            phone: (value) => {
                if (typeof value === "string")
                    return !isValidPhoneNumber(value)
                else return true
            }
        },
    });


    const handleSubmit = async (values) => {
        window.open(`https://api.whatsapp.com/send/?phone=%2B5493512086545&text=¡Hola%21+Buenos+días%2C+quisiera+más+información+sobre+${academicUnitName}...&type=phone_number&app_absent=0`, '_blank');

        setIsLoading(true)

        try {
            // create lead
            const createLeadJsonData = {
                email: values.email,
                name: values.name,
                phone: values.phone,
                interestAreas: [academicUnitId],
                source: 'ADVISOR_MODAL',
                sendEmail: false,
                flow: null,
            }

            await axios.post(`${process.env.REACT_APP_BACKEND_SERVER}/info/createLead`, createLeadJsonData)
        } catch (error) {
            console.log(error)
        } finally {
            setIsLoading(false)
            onClose()
        }
    }

    const ref = createRef()


    return <Modal
        opened={opened}
        onClose={onClose}
    >
        <Stack>
            <h3 style={{ fontSize: 'var(--fs-h3)', textAlign: 'left' }}>
                {modalTitle}
            </h3>
            <p style={{ fontSize: "var(--fs-h4)" }}>¡Hablemos por Whatsapp!</p>

            <form
                onSubmit={
                    form.onSubmit((values) => handleSubmit(values))
                }>
                <Grid>
                    <Grid.Col span={12}>
                        <TextInput
                            label='Escribe tu nombre'
                            {...form.getInputProps('name')}
                        />

                    </Grid.Col>
                    <Grid.Col span={12}>
                        <TextInput
                            label='Escribe tu email'
                            {...form.getInputProps('email')}
                        />
                    </Grid.Col>
                    <Grid.Col span={12}>
                        <PhoneInputField
                            ref={ref}
                            name="phone"
                            fieldError={form.errors.phone}
                            {...form.getInputProps("phone")}
                        />
                    </Grid.Col>
                    <Grid.Col span={12} mt={16}>
                        <Button fullWidth color='#FF7BAC' type='submit' disabled={isLoading}>
                            {isLoading ? <Loader /> : <Flex align='center' gap={8}><span style={{fontSize:"var(--fs-small)"}} >Hablar por Whatsapp</span><IconBrandWhatsapp/></Flex>}
                        </Button>
                    </Grid.Col>
                </Grid>
            </form>
        </Stack>
    </Modal>
}